<template>
  <div class="container-fluid">
    <vx-card title="Carga archivo" class="mt-5" style="min-height: 40vh;">
      <div class="row">
        <!-- Button container-->
        <div class="col-md-12">
          <file-uploader
            @onFileUploadedSuccess="fileUploadedSuccessHandler"
            @onFileUploadedFailed="fileUploadedFailedHandler"
            :endpoint-upload-file="`${apiEndpoint}/api/direct-billing/investor/file`"
            label="Buscar archivo de respuesta"></file-uploader>
        </div>
        <!-- Preview Container -->
        <div class="col-md-12 mt-5">
          <vs-table :data="dispersions">
            <template slot="thead">
              <th id="alias">Alias</th>
              <th id="bankName">Nombre banco</th>
              <th id="amount">Monto</th>
              <th id="description">Descripción</th>
              <th id="executionDate">Fecha ejecución</th>
              <th id="status">Estatus

              </th>
            </template>
            <template slot-scope="{data}">
              <tr v-for="(d, i) in data" :key="i">
                <td>
                  <span v-if="d.q">
                    <em class="fas fa-sync text-warning" v-if="d.q.s === 'processing'"></em>
                    <em class="fas fa-check text-success" v-if="d.q.s === 'done'"></em>
                    <vx-tooltip :text="d.q.m" style="float: left; margin-right: 5px;">
                      <em class="fas fa-times text-danger" v-if="d.q.s === 'error'"></em>
                    </vx-tooltip>
                </span>
                  {{ d.t.alias }}
                </td>
                <td>{{ d.t.bankName }}</td>
                <td>{{ d.t.amount }}</td>
                <td>{{ d.t.description }}</td>
                <td>{{ d.t.executionDate }}</td>
                <td>
                  <span v-if="d.t.status === 'Procesado'">
                    <em class="fa fa-circle font-small-3 text-success mr-50"></em>
                    {{ d.t.status }}
                  </span>
                  <span v-else>
                    <em class="fa fa-circle font-small-3 text-danger mr-50"></em>
                    Devuelto: <strong>{{ d.t.status }}</strong>
                  </span>
                </td>
              </tr>
            </template>
          </vs-table>
        </div>
      </div>

      <template slot="footer">
        <vs-button
          :disabled="dispersions.length === 0"
          @click="paymentProcessorHandler"
          color="success"
          class="float-right">
          Procesar Pagos
        </vs-button>
      </template>
    </vx-card>
  </div>
</template>

<script>
import FileUploader from "@views/admin/DirectBilling/FileUploader";

export default {
  name: "InvestorPreviewResponseFile",
  components: {FileUploader},
  data: () => ({
    response: {},
    dispersions:[],
    queue: [],
    apiEndpoint: ""
  }),
  mounted() {
    this.apiEndpoint = process.env.VUE_APP_API_DOMAIN;
  },
  methods: {
    fillDispersions(source) {
      // reset data
      this.dispersions = [];
      for (let trx of source) {
        this.dispersions.push({
          q: {s: '', m: ''},
          t: trx
        })
      }
    },
    fileUploadedSuccessHandler(ev) {
      this.fillDispersions(ev.data);
    },
    fileUploadedFailedHandler(ev) {

    },
    /**
     * @param {Array} dispersions
     */
    dispersionQueueFinishedEvent(dispersions) {
    },
    /**
     * @param {Object} dispersion
     * @param {Object} apiResponse
     */
    dispersionProcessedEvent(dispersion, apiResponse) {
    },
    async paymentProcessorHandler() {
     if (confirm("¿Esta seguro de procesar esté archivo?")) {
       await this.processor();
     }
    },
    //iterator pattern
    async processor() {
      // convert to queue
      let trxNotProcessed = this.dispersions.filter((d) => {
        return d.q.s === "";
      })

      if(trxNotProcessed.length === 0) {
        // stop iterator when all trx was process
        this.dispersionQueueFinishedEvent(this.dispersions);
        return;
      }

      trxNotProcessed[0].q.s = "processing";
      try {
        let response = await axios.post(`/api/direct-billing/investor/transaction`, {
          transaction: trxNotProcessed[0].t
        })

        this.dispersionProcessedEvent(trxNotProcessed[0].t, response.data);

        trxNotProcessed[0].q.s = "done";
      } catch (e) {
        trxNotProcessed[0].q.s = "error";
        if(e.response.status === 422) {
          trxNotProcessed[0].q.m = e.response.data.message;
        } else {
          trxNotProcessed[0].q.m = e.response.data;
        }
      }

      await this.processor();
    },
  }
}
</script>
